export default "__VITE_PUBLIC_ASSET__f7b2c902__"